module.exports = __webpack_public_path__ + "img/icon_tel.65a25e81.png";